<template>
  <v-app>
    <v-row
      align="center"
      justify="center"
    >
      <base-material-card
        color="primary"
      >
        <template v-slot:heading>
          <v-img
            lazy-src="../../assets/logo22.png"
            aspect-ratio="4.9"
            width="375"
            contain
            src="../../assets/logo22.png"
          />
        </template>
        <v-container class="py-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              v-model="credentials.username"
              label="Usuario"
              :rules="rules.username"
              prepend-icon="mdi-account-circle"
            />
            <v-text-field
              v-model="credentials.password"
              label="Contraseña"
              :rules="rules.password"
              prepend-icon="mdi-lock"
              type="password"
            />
            <v-row
              align="center"
              justify="center"
            >
              <v-btn
                color="primary"
                class="mr-0"
                :disabled="!valid"
                @click="login"
              >
                Iniciar sesión
              </v-btn>
            </v-row>
            <br>
            <v-row
              align="center"
              justify="center"
              style="margin-top:30px;margin-bottom:30px"
            >
              <v-btn
                rounded
                big
                text
                to="/recuperar"
                color="primary"
              >
                ¿Olvidaste tu contraseña?
              </v-btn>
            </v-row>
          </v-form>
        </v-container>
      </base-material-card>
    </v-row>
    <v-row>
      <dashboard-core-view />
    </v-row>
  </v-app>
</template>

<script>
  import axios from 'axios'
  import router from '../../router'
  export default {
    name: 'Auth',
    components: {
    },
    data: () => ({
      expandOnHover: false,
      credentials: {},
      valid: true,
      loading: false,
      rules: {
        username: [
          v => !!v || 'El usuario es requerido',
          v => (v && v.length > 3) || 'Mínimo 3 caracteres',
        ],
        password: [
          v => !!v || 'La contraseña es requerida',
          v => (v && v.length >= 5) || 'Debe tener por lo menos 5 digitos',
        ],
      },
    }),
    methods: {
      login () {
        if (this.$refs.form.validate()) {
          this.loading = true
          axios.post(window.location.protocol + '//' + window.location.hostname + ':8000/inventario/' + 'api-token-auth/', this.credentials)
            .then(data => {
              const token = data.data.token
              axios.defaults.headers.common.Authorization = 'token ' + token
              this.$session.start()
              this.$session.set('token', data.data.token)
              this.$session.set('puerto', '8000/inventario/')
              axios.post(window.location.protocol + '//' + window.location.hostname + ':' + this.$session.get('puerto') + 'get_id/', { username: this.credentials.username })
                .then((res) => {
                  this.$session.set('iduser', res.data.id)
                  router.push('pages/Inventario')
                })
            }).catch(e => {
              this.loading = false
              this.$swal({
                text: 'Usuario o contraseña equivocada',
                showConfirmButton: false,
                showCloseButton: true,
                timer: 3000,
                icon: 'warning',
              })
              console.log(e)
            })
        }
      },
    },
  }
</script>
